import Vue from 'vue';
import './plugins/axios';
import './plugins/sweetalert';
import App from './App.vue';
import router from './router';
import store from './store';
import VueAnalytics from 'vue-analytics';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import i18n from './i18n';

const isProd = process.env.NODE_ENV == 'production'

Vue.config.productionTip = false;

Vue.use(require('vue-moment'));

if (isProd){
  Vue.use(VueAnalytics, {
    id: process.env.ANALYTICS_KEY,
    router,
    autoTracking: {
      page: true
    },
    debug:{
      enabled: !isProd,
      sendHitTask: isProd
    }
  });
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  name: process.env.VUE_APP_TITLE,
  data: () => ({
    title: process.env.VUE_APP_TITLE
  }),
  render: h => h(App)
}).$mount('#app');
